import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { useOidcAuth } from '@/features/login/model/use-oidc-auth';
import { OidcProvider } from '@/shared/config/oidc-config';

export const ExternalUsersSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const fromLocal = location.state?.from;
  const returnUrl = fromLocal ? `${fromLocal.pathname}${fromLocal.search}${fromLocal.hash}` : undefined;

  const { loginWithRedirect, isLoading } = useOidcAuth(OidcProvider.CIAM);

  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle className="text-lg">{t('login.screen.sso.login.panel.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button
          variant="secondary"
          className="w-full"
          size="lg"
          onClick={() => loginWithRedirect(returnUrl)}
          disabled={isLoading}>
          {isLoading ? 'Logging in...' : t('login.user.button')}
        </Button>
      </CardContent>
    </Card>
  );
};
